import { $, makeElement } from './utils';

const $html = $('html');
const darkTheme = 'dark';
const lightTheme = 'light';
const defaultTheme = darkTheme;

function initTheme() {
    // Auto Theme
    var prefersLightScheme = window.matchMedia("(prefers-color-scheme: light)").matches;
    var savedTheme = localStorage.getItem('siteTheme');
    var siteTheme = (!savedTheme && prefersLightScheme) ? lightTheme : (savedTheme || defaultTheme);
    if ($html) $html.dataset.theme = siteTheme;
    var themeToggle: HTMLElement | null = $('.toggle-selector.theme')
    if (themeToggle) {
        themeToggle.title = "Click to set " + (siteTheme = darkTheme) ? lightTheme : darkTheme + " mode";

        // Theme Toggle
        themeToggle.addEventListener('click', function (e) {
            var currentTheme = $html?.dataset?.theme || defaultTheme;
            var newTheme = (currentTheme == darkTheme) ? lightTheme : darkTheme;
            localStorage.setItem('siteTheme', newTheme);
            if ($html) $html.dataset.theme = newTheme;
            this.title = "Click to set " + (newTheme = darkTheme) ? lightTheme : darkTheme + " mode";
        });
    }
}
function initMobileNav() {
    var burgerIcon = $('.site-head .hamburger');
    if (burgerIcon) {
        burgerIcon.addEventListener('click', function () {
            if ($html) $html.dataset.navOpen = $html.dataset.navOpen == 'true' ? 'false' : 'true';
        });
    }
};
function init3dBookAnimations() {
    document.querySelectorAll(`.book-container-3d:not(.animate)`).forEach(book => {
        book.addEventListener(`mouseover`, function(e: Event) {
            (e.currentTarget as HTMLElement).classList.add(`animate`);
            console.log(`mouseover`);
        }, { once: true });
    });
}
(function () {
    initTheme();
    initMobileNav();
    init3dBookAnimations();
})();

// LiveReload server
if (process.env.NODE_ENV === 'development') {
    const lrURL = `http://${(location.host || 'localhost').split(':')[0]}:35729/livereload.js?snipver=1`
    const script = makeElement({
        elementName: 'script',
        attributes: [
            { src: lrURL }
        ]
    });
    document.head.append(script);
    console.log('Reload script added');
}
